import { useState } from 'react';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { useCsvExport } from '../data/useCsvExport';
import { useIsPreview } from '../hooks/useIsPreview';
import { usageTracker } from '../utils/usageTracker';
import { useBreakpoint } from 'portals-platform-lib';
import { ExportConfirmModal } from './atoms/ExportConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function CsvExportButton({
  totalCount
}) {
  const {
    sort,
    ticketView,
    statusFilter,
    searchString,
    createDateFilter,
    lastActivityFilter
  } = useTicketListingsSortAndFilters();
  const csvExport = useCsvExport({
    sort,
    ticketView,
    statusFilter,
    searchString,
    createDateFilter,
    lastActivityFilter
  });
  const isPreview = useIsPreview();
  const isMobile = useBreakpoint() === 'mobile';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isEmpty = totalCount === 0;
  const handleConfirm = () => {
    setIsModalOpen(false);
    usageTracker.track('Customer Portal App', 'Tickets Discovered', {
      action: 'tickets-exported',
      screen: 'ticket-listings'
    });
    csvExport.doExport();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isModalOpen && /*#__PURE__*/_jsx(ExportConfirmModal, {
      onConfirm: handleConfirm,
      onClose: () => setIsModalOpen(false),
      ticketView: ticketView,
      statusFilter: statusFilter,
      createDateFilter: createDateFilter,
      lastActivityFilter: lastActivityFilter,
      searchString: searchString,
      totalCount: totalCount
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: isEmpty ? I18n.text('customer-portal-app.ticketListings.export.modal.noRecordsTooltip') : undefined,
      children: /*#__PURE__*/_jsxs(LoadingButton, {
        "data-test-id": 'csv-export-button',
        marginInline: "0",
        size: "small",
        onClick: () => !isPreview && !isEmpty && setIsModalOpen(true),
        use: "secondary-alt",
        disabled: isEmpty,
        loading: csvExport.loading,
        failed: !!csvExport.error,
        "aria-label": I18n.text('customer-portal-app.ticketListings.export.button'),
        children: [/*#__PURE__*/_jsx(DownloadIcon, {}), !isMobile && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.ticketListings.export.button"
        })]
      })
    })]
  });
}